import dayjs from 'dayjs'

export const validationRules = (manufactureDate: string) => {
  return {
    day: {
      max: 31,
      min: 1,
    },
    month: {
      max: 12,
      min: 1,
    },
    year: {
      max: dayjs().year() + 1,
      min: parseInt(dayjs(manufactureDate).format('YYYY')),
    },
  }
}
